import { render } from "./SelectTrueFalse.vue?vue&type=template&id=684c4476"
import script from "./SelectTrueFalse.vue?vue&type=script&lang=js"
export * from "./SelectTrueFalse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__